import React from 'react';
import { formatDate } from 'common-date/format';
import { Button } from '@mui/material';
import useRUMView from 'common-datadog/useRUMView';

import { DateFormats } from 'common-date/formats';
import Screen from '../Screen';
import Disclaimers from '../Disclaimers';

import usePrequal from '../../resources/prequal/usePrequal';

const DeclinedReminder = () => {
  useRUMView('declined_reminder');
  const { data: prequal } = usePrequal();

  return (
    <Screen
      header="Unfortunately, your previous application was not approved."
      subheader={`You'll be eligible to reapply for financing on ${formatDate(prequal.expirationDate, DateFormats.MonthDayYearLongDisplay)}.`}
    >
      <Disclaimers textAlign="center">
        Please note that your credit score was not affected.
      </Disclaimers>
      <Button href={`/${process.env.PREFIX}/auth/logout`}>
        Sign Out
      </Button>
    </Screen>
  );
};

export default DeclinedReminder;
